import { arrayMove } from '@dnd-kit/sortable';
import type { TemplateFormsState } from '../index';
import type { LayoutType } from 'types';

interface Payload {
  layoutType: LayoutType;
  oldIndex: number;
  newIndex: number;
}

export const reorderSections = (state: TemplateFormsState, { payload }: { payload: Payload }) => {
  const { layoutType, oldIndex, newIndex } = payload;

  state[layoutType].sections = arrayMove(state[layoutType].sections, oldIndex, newIndex);
};
